import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/** Market notice banner: clarifies asking/market prices vs finalized notary transactions. */
@Component({
  selector: 'app-market-notice',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './market-notice.component.html',
  styleUrl: './market-notice.component.scss',
})
export class MarketNoticeComponent {
  text = input<string>('');
}
